export default __webpack_public_path__ + "static/media/courses-icon.0ba90f06.svg";